import React from 'react';

import SideMenu from '../../components/SideMenu';
import LastTransactions from '../../components/LastTransactions';
import AccountInfo from '../../components/AccountInfo';
import AccountInfoMobile from '../../components/AccountInfoMobile';
import Balance from '../../components/Balance';
import Footer from '../../components/Footer';
import Quotes from '../../components/Quotes';
import { getTranslations } from '../../services/languageUtils';
import { isMutual } from '../../utils/isMutual';
import { isMtBank } from '../../utils/isMtBank';
import { isVoluti } from '../../utils/isVoluti';

class Home extends React.Component {
  constructor(props) {
      super(props);

      this.state = {
        translations: {}
      };
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  componentDidMount() {
    this.loadTranslations();
  }

  render() {
   return (
    <section id="userPage" className="userPage">
      <SideMenu />

      <div className="contentData">
        <div className="contentScroll">
          <Quotes />
          <p className="title">{this.state.translations.welcomeHome}, {sessionStorage.getItem('nameUser')+''}!</p><br/>
          <div className="contentSubData">
            <Balance />
            <span className="desktop">
              <br/><br/><br/><br/>
              <AccountInfo />
            </span>

            <span className="mobile">
              <br/><br/><br/><br/>
              <AccountInfoMobile />
            </span>

          </div>
          {
            !isMutual() &&
            !isMtBank() &&
            !isVoluti() &&
            <LastTransactions />
          }
          
          <Footer />
        </div>
      </div>
    </section>
   );
  }
 }

export default Home;
